// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountsDropdown-module__root__22Dzs","dropdown-width":"AccountsDropdown-module__dropdown-width__1yHV4"};